'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.issuerAdminTypesAll = exports.userTypes = exports.endUserTypes = exports.adminTypes = exports.adminTypesAll = undefined;

var _extends = _assign2.default || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Dictionary = require('./classes/Dictionary');

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var adminMap = {
  TENANT_ADMIN: 'Tenant Administrator',
  READ_ONLY_ADMIN: 'Read Only Tenant Administrator',
  MODERATOR_ADMIN: 'Moderator Administrator'
};

var adminMapAll = _extends({}, adminMap, {
  SUPER_ADMIN: 'Super Administrator'
});

var endUserMap = {
  BANKER: 'Banker',
  INVESTOR: 'Investor',
  ISSUER: 'Issuer'
};

var userMap = _extends({}, endUserMap, {
  ADMIN: 'Administrator'
});

var issuerMapAll = {
  TEAM_MEMBER: 'Team Member',
  ISSUER_SUPER_ADMIN: 'Issuer Admin',
  ISSUER_MODERATOR_ADMIN: 'Issuer Banker'
};

var adminTypesAll = exports.adminTypesAll = new _Dictionary2.default(adminMapAll);

var adminTypes = exports.adminTypes = new _Dictionary2.default(adminMap);

var endUserTypes = exports.endUserTypes = new _Dictionary2.default(endUserMap);

var userTypes = exports.userTypes = new _Dictionary2.default(userMap);

var issuerAdminTypesAll = exports.issuerAdminTypesAll = new _Dictionary2.default(issuerMapAll);

exports.default = userTypes;